export const merchantTypes = {
  evbma: {
    planId: 8,
    durationId: 3,
    default: {
      loginHeader: 'Ready to set up your Pro Membership?',
      loginCopy: 'Create an Account and redeem your gift card to access all of the benefits of Pro Membership. Already have a Basic Membership? Login to redeem your code.'
    }
  },
  evbmm: {
    planId: 8,
    durationId: 4,
    default: {
      loginHeader: 'Ready to set up your Pro Membership?',
      loginCopy: 'Create an Account and redeem your gift card to access all of the benefits of Pro Membership. Already have a Basic Membership? Login to redeem your code.'
    }
  },
  redeem: {
    default: {
      loginHeader: 'Ready to set up your Pro Membership?',
      loginCopy: 'Create an Account and redeem your gift card to access all of the benefits of Pro Membership. Already have a Basic Membership? Login to redeem your code.'
    }
  },
  claim: {
    default: {
      loginHeader: 'Ready to set up your Membership?',
      loginCopy: 'Create an Account and redeem your gift card to access all premium benefits. Already have a Basic Membership? Login to redeem your code.'
    },
    eastmans: {
      loginWelcome: 'Welcome Eastmans\' members!',
      loginHeader: 'Ready to claim your BaseMap Pro Subscription?',
      loginCopy: 'Create an account and use your Eastmans promo code to activate'
    }
  }
}

export const getLoginCopies = () => {
  const pname = window.location.pathname.substring(1),
    search = window.location.search.substring(1)

  return search ? merchantTypes[pname][search] : merchantTypes[pname]['default']
}